module.exports = __webpack_public_path__ + "src/assets/sounds/plastic_1_sound.mp3";